import type { Asset } from 'contentful'
import type { Document } from '@contentful/rich-text-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import ImeiCheckerWithComparison from './ImeiChecker'

interface ImeiCheckerFields {
  entryTitle: string
  checkerBannerHeading?: string
  checkerSubcopy?: string
  checkerTooltip?: string
  checkerCta?: string
  xlImage?: Asset
  mdImage?: Asset
  xsImage?: Asset
  imageAlt?: string
  resultHeading?: string
  resultSuccessMessage?: string
  resultSuccessSubcopy?: Document
  resultNonCompatibleMessage?: string
  resultNonCompatibleSubcopy?: Document
  resultSplitSuccessMessage?: string
  resultSplitSuccessSubcopy?: Document
}

const getAssetUrl = (asset?: Asset): string | undefined => asset?.fields?.file?.url as string | undefined

const ContentfulImeiChecker = withContentful<ImeiCheckerFields>(ImeiCheckerWithComparison, {
  xlImageSrc: (props) => getAssetUrl(props.fields.xlImage),
  mdImageSrc: (props) => getAssetUrl(props.fields.mdImage),
  xsImageSrc: (props) => getAssetUrl(props.fields.xsImage),
  imageAlt: (props) => props.fields.imageAlt,
  checkerBannerHeading: (props) => props.fields.checkerBannerHeading,
  checkerSubcopy: (props) => props.fields.checkerSubcopy,
  checkerTooltip: (props) => props.fields.checkerTooltip,
  checkerCta: (props) => props.fields.checkerCta,
  resultHeading: (props) => props.fields.resultHeading,
  resultSuccessMessage: (props) => props.fields.resultSuccessMessage,
  resultSuccessSubcopy: (props) => props.fields.resultSuccessSubcopy,
  resultNonCompatibleMessage: (props) => props.fields.resultNonCompatibleMessage,
  resultNonCompatibleSubcopy: (props) => props.fields.resultNonCompatibleSubcopy,
  resultSplitSuccessMessage: (props) => props.fields.resultSplitSuccessMessage,
  resultSplitSuccessSubcopy: (props) => props.fields.resultSplitSuccessSubcopy,
})

export default ContentfulImeiChecker
